import {
  startOfDay,
  startOfQuarter,
  startOfYear,
  subDays,
  subMonths,
  subWeeks,
  subYears,
  endOfDay,
  startOfMonth,
} from 'date-fns';

export const dateRangeUnits = {
  HOUR: 'hour',
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year',
};

export const dateRanges = {
  today: {
    label: 'Today',
    start: startOfDay(new Date()),
    end: endOfDay(new Date()),
    units: [dateRangeUnits.HOUR],
    defaultUnit: dateRangeUnits.HOUR,
  },
  yesterday: {
    label: 'Yesterday',
    start: startOfDay(subDays(new Date(), 1)),
    end: endOfDay(subDays(new Date(), 1)),
    units: [dateRangeUnits.HOUR],
    defaultUnit: dateRangeUnits.HOUR,
  },

  lastSevenDays: {
    label: 'Last 7 days',
    start: startOfDay(subDays(new Date(), 7)),
    end: endOfDay(new Date()),
    units: [dateRangeUnits.HOUR, dateRangeUnits.DAY],
    defaultUnit: dateRangeUnits.DAY,
  },
  lastFourWeeks: {
    label: 'Last 4 weeks',
    start: startOfDay(subWeeks(new Date(), 4)),
    end: endOfDay(new Date()),
    units: [dateRangeUnits.DAY, dateRangeUnits.WEEK],
    defaultUnit: dateRangeUnits.WEEK,
  },
  lastThreeMonths: {
    label: 'Last 3 months',
    start: startOfDay(subMonths(new Date(), 3)),
    end: endOfDay(new Date()),
    units: [dateRangeUnits.DAY, dateRangeUnits.WEEK, dateRangeUnits.MONTH],
    defaultUnit: dateRangeUnits.MONTH,
  },
  lastTwelveMonths: {
    label: 'Last 12 months',
    start: startOfDay(subMonths(new Date(), 12)),
    end: endOfDay(new Date()),
    units: [dateRangeUnits.DAY, dateRangeUnits.WEEK, dateRangeUnits.MONTH],
    defaultUnit: dateRangeUnits.MONTH,
  },

  monthToDate: {
    label: 'Month to date',
    start: startOfMonth(new Date()),
    end: endOfDay(new Date()),
    units: [dateRangeUnits.DAY, dateRangeUnits.WEEK],
    defaultUnit: dateRangeUnits.DAY,
  },
  quarterToDate: {
    label: 'Quarter to date',
    start: startOfQuarter(new Date()),
    end: endOfDay(new Date()),
    units: [dateRangeUnits.DAY, dateRangeUnits.WEEK, dateRangeUnits.MONTH],
    defaultUnit: dateRangeUnits.MONTH,
  },
  yearToDate: {
    label: 'Year to date',
    start: startOfYear(new Date()),
    end: endOfDay(new Date()),
    units: [dateRangeUnits.DAY, dateRangeUnits.WEEK, dateRangeUnits.MONTH],
    defaultUnit: dateRangeUnits.MONTH,
  },

  allTime: {
    label: 'All time',
    start: subYears(new Date(), 99),
    end: endOfDay(new Date()),
    units: [dateRangeUnits.WEEK, dateRangeUnits.MONTH, dateRangeUnits.YEAR],
    defaultUnit: dateRangeUnits.MONTH,
  },
};
